//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance_exchange",
    data() {
        return {
            title: "积分专区",
            score: "", //可用积分
            showTips: false, // 兑换弹框
            state: false, //说明弹框
            page: 1, //获取第几页数据
            per_page:20, //每一页条数
            coupons: [], //优惠券信息
            seperate: "", //区分弹窗显示内容  0提示去绑定 1兑换
            coupon_info: "", //每个优惠券信息
            url: window.location.href, //当前地址
            description: "", //优惠券说明
            order_score: "", //积分排序 asc正序 desc倒序
            order_denomination: "", //金额排序  asc正序 desc倒序
            is_able: 0, //我能兑换的	1为可兑换
            couponShow: true //优惠券列表有无数据
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.get_scroe();
        }
    },
    methods: {
        //获取token
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url, function() {
                self.get_scroe();
                self.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
            }); //生成token
        },
        //获取用户可用积分
        get_scroe() {
            var self = this;
            this.$EpetJs.Common.get("public/user/score", {}).then(
                ({ data }) => {
                    if (data.status_code == "200") {
                        self.score = data.data.score;
                    }
                }
            );
        },
        infiniteHandler($state) {
            if (sessionStorage.getItem("token") == null) {
                return;
            }
            this.get_coupons($state);
        }, 
        //获取优惠券列表
        get_coupons($state) {
            var self = this;
            this.$EpetJs.Common.get(
                "/v2/public/coupons?page=" +
                    this.page +
                    "&per_page=" +
                    this.per_page +
                    "&order_score=" +
                    this.order_score +
                    "&order_denomination=" +
                    this.order_denomination +
                    "&is_able=" +
                    this.is_able,
                {}
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    if (data.data.length > 0) {
                        self.coupons = self.coupons.concat(data.data);
                        self.page += 1;
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                    if (self.coupons == "") {
                        self.couponShow = false;
                    } else {
                        self.couponShow = true;
                    }
                }
            });
        },
        //积分排序
        change_score() {
            if (this.order_score == "asc") {
                this.order_score = "desc";
            } else {
                this.order_score = "asc";
            }
            this.coupons = [];
            this.page = 1;
            this.$nextTick(() => {
                this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
            });
        },
        //金额排序
        change_denomination() {
            if (this.order_denomination == "asc") {
                this.order_denomination = "desc";
            } else {
                this.order_denomination = "asc";
            }
            this.coupons = [];
            this.page = 1;
            this.$nextTick(() => {
                this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
            });
        },
        //我能兑换
        change_able() {
            if (this.is_able == 0) {
                this.is_able = 1;
            } else {
                this.is_able = 0;
            }
            this.coupons = [];
            this.page = 1;
            this.$nextTick(() => {
                this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
            });
        },
        //获取用户信息 查看是否绑定手机
        get_user(coupon_info) {
            this.coupon_info = coupon_info;
            this.showTips = true;
        },
        //点击兑换
        exchange() {
            //优惠券ID
            var self = this;
            this.$EpetJs.Common.post(
                "public/user/coupons/" + this.coupon_info.id + "/exchange",
                {
                    shop_id:
                        self.coupon_info.coupon_type == 2
                            ? self.coupon_info.shop_id
                            : ""
                }
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    this.$router.push({
                        name: "alliance_myexchange",
                        query: { status: 1 }
                    });
                } else {
                    self.$vux.toast.text(data.message);
                }
            });
        },
        //跳转查询页
        go_inquire() {
            window.location.href =
                this.$EpetJs.Const.PROTOCOL +
                "//" +
                window.location.host +
                "/inquire";
        },
        //说明弹窗显示
        stateShow(item) {
            this.state = true;
            this.description = item.description;
        },
        //跳转到我的兑换
        go_myexchange() {
            this.$router.push({ name: "alliance_myexchange" });
        },
    }
};
